type DataLayerPayload = Record<string, unknown>;

declare global {
	interface Window {
		dataLayer?: Array<DataLayerPayload>;
	}
}

const getDataLayer = (): Array<DataLayerPayload> | null => {
	if (typeof window === "undefined") return null;
	window.dataLayer = window.dataLayer || [];
	return window.dataLayer;
};

export const identifyUser = (userId: string | number | null | undefined, email: string | null | undefined) => {
	if (!userId || !email) return;
	const dataLayer = getDataLayer();
	if (!dataLayer) return;
	dataLayer.push({
		user_id: String(userId),
		email,
	});
};

export const trackEvent = (name: string, payload: DataLayerPayload = {}) => {
	if (!name) return;
	const dataLayer = getDataLayer();
	if (!dataLayer) return;
	dataLayer.push({ event: name, ...payload });
};

export enum TrackedEvent {
	BarcodeViewed = "Barcode Viewed",
	InternalNotesViewed = "Internal Notes Viewed",
	PasswordCopied = "Password Copied",
	PasswordViewed = "Password Viewed",
}
